import * as React from 'react';
import { useState } from 'react';
import { CustomReferenceRole, Reference, Part, PartDefinition, ReferenceAssignmentsRequest, filterPartDefinitionsForReferenceType, getShortTypeName, getPartLabel, selectAllReferenceRoles, getUasId, selectAllPartDefinitions, getRefMap, getPartValue, selectCurrentReference, selectReferenceAssignments, selectAllReferences, loadAllTaxonomyReferences, loadAllReferenceAssignments, clearSelectedReference, setSelectedReference } from '../../redux/TaxonomyReferenceSlice';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Table, FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Select, { useEffect } from 'react-select';
import { DtsConcept, loadTaxonomyConcept, resetTaxonomyConceptState, getSelectedTaxonomyConcept } from '../../redux/TaxonomyConceptSlice';
import enums from '../../utils/enums';
import { selectEditReference, getTaxonomyChanges, addReferenceRoleChange, getReferenceRoleChanges, TaxonomyChangesState, addPartDefinitionChange, getPartDefinitionChanges } from '../../redux/TaxonomyChangesSlice';
import utilityHelper from '../../utils/utilityHelper';
import { setIsTaxonomyDirty } from '../../redux/TaxonomyVersionSlice';
import { Edit } from '../../redux/MiscSlice';
import { ActiveTaxonomyVersionInfo, TaxonomyVersionInfo, selectCurrentVersion, setTaxonomyVersion } from '../../redux/TaxonomyVersionSlice';

//import { statSync } from 'node:fs';

interface ddSelection {
    dropdown: string,
    dropdowntype: string,
    role: CustomReferenceRole | null
}

interface ddOption {
    name: string;
    documentation: string;
    effectiveDate: string,
    deprecationDate: string
}

interface ddPartSelection {
    dropdown: string,
    dropdowntype: string,
    part: PartDefinition | null
}

interface ddPartOption {
    name: string;
    documentation: string;
}


function ReferenceTypeAndPartManager(props: any) {

    const dispatch = useAppDispatch();
    const selectedVersion: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    var partDefinitions: PartDefinition[] = useAppSelector(selectAllPartDefinitions);
    var changes: TaxonomyChangesState | null = useAppSelector(getTaxonomyChanges);
    var roleChanges: CustomReferenceRole[] = useAppSelector(getReferenceRoleChanges);
    var partDefinitionChanges: PartDefinition[] = useAppSelector(getPartDefinitionChanges);
    const currentReference: Reference | null = useAppSelector(selectEditReference);
    var references: Array<Reference> = useAppSelector(selectAllReferences);
    var selectedReference: Reference | null = useAppSelector(selectCurrentReference);

    const [state, setState] = useState<Array<ddSelection>>([{
        dropdown: "",
        dropdowntype: "",
        role: null
    }]);

    const addPartId = function (partName: string, refMap: any, idparts: string[]) {
        if (refMap && refMap.hasOwnProperty(partName)) {
            idparts.push(refMap[partName]);
        }
    }

    const createReferenceKey = function (reference: Reference, refMap: any): string {
        var idparts : any[] = [];
        idparts.push(reference.type.replace("https", "http"));
        addPartId("Name", refMap, idparts);
        addPartId("Chapter", refMap, idparts);
        addPartId("Paragraph", refMap, idparts);
        idparts.push(getUasId(reference, refMap));
        return idparts.join("_");
    }

    const [refType, setRefType] = useState("http://www.xbrl.org/2003/role/reference")
//    const [refId, setRefId] = useState("");
    const [refName, setRefName] = useState("");
    const [refTypeEffectiveDate, setRefTypeEffectiveDate] = useState(new Date().toISOString().split('T')[0]);
    const [partDefinitionEffectiveDate, setPartDefinitionEffectiveDate] = useState(new Date().toISOString().split('T')[0]);
    const [refTypeDeprecationDate, setRefTypeDeprecationDate] = useState("");
    const [partDefinitionDeprecationDate, setPartDefinitionDeprecationDate] = useState("");
    const [customName, setCustomName] = useState("");
    const [customDocumentation, setCustomDocumentation] = useState("");
    const [partDefinitionDatatype, setPartDefinitionDatatype] = useState("");
    const [customPartDefinitionDatatype, setCustomPartDefinitionDatatype] = useState("STRING");
    const [customPartGroup, setCustomPartGroup] = useState<string>("");
    const [partGroup, setPartGroup] = useState<string>("");

    const referenceRoles = useAppSelector(selectAllReferenceRoles);

    const getDateAttributeOrDefault = function(attr: string | null) : string {
        if (attr) {
            return attr.split("T")[0];
        }
        return ""; 
    }
    const convertToOption = function (role: CustomReferenceRole): ddOption {
        if (!role) {
            return { name: "", documentation: "", effectiveDate: "", deprecationDate: "" };
        }
        return { name: getShortTypeName(role), documentation: role.documentation, effectiveDate: getDateAttributeOrDefault(role.effectiveDate), deprecationDate: getDateAttributeOrDefault(role.deprecationDate) };
    }
    const collectReferenceRoles = function (rChanges: CustomReferenceRole[]): CustomReferenceRole[] {
        var result: CustomReferenceRole[] = [];
        if (referenceRoles) {
            result = result.concat(referenceRoles);
        }
        result = result.concat(rChanges);
        return result;
    }
    const [allReferenceRoles, setAllReferenceRoles] = useState<CustomReferenceRole[]>(collectReferenceRoles(roleChanges));

    const generateRoleIdMap = function (allRoles: CustomReferenceRole[]): any {
        const newIdMap : any =
        allRoles.reduce(function (map: any, r: CustomReferenceRole) {
            map[getShortTypeName(r)] = r;
            return map;
        }, {})
        return newIdMap;
    }
    const [idMap, setIdMap] = useState(generateRoleIdMap(allReferenceRoles));

    const getOptions = function (allRoles : CustomReferenceRole[]): ddOption[] {
        var options: ddOption[] = [];
        for (var pd of allRoles) {
            options.push(convertToOption(pd));
        }
        return options;
    }
    const [optionList, setOptionList] = useState(getOptions(allReferenceRoles));

    const [selectedOption, setSelectedOption] = useState<CustomReferenceRole>({ name: "", documentation: "", effectiveDate: null, deprecationDate: null });


    // Handle Event
    const handleChange = (e: any, action: any) => {

        var ddName: string = action.name;
        var roleName: string = e.value;
        var role: CustomReferenceRole | null = null;
        var ddType = "CustomReferenceRole";
        var option: ddOption = { name: "", documentation: "", effectiveDate: "", deprecationDate: "" };
        var allRoles = collectReferenceRoles(roleChanges);
        var roleDef: CustomReferenceRole | null | undefined = (allRoles.length > 0) ? allRoles.find(ro => getShortTypeName(ro) === roleName) : null;
        if (roleDef) {
            option = { name: roleDef.name, documentation: roleDef.documentation, effectiveDate: getDateAttributeOrDefault(roleDef.effectiveDate), deprecationDate: getDateAttributeOrDefault(roleDef.deprecationDate) };
            setRefTypeEffectiveDate(getDateAttributeOrDefault(roleDef.effectiveDate));
            setRefTypeDeprecationDate(getDateAttributeOrDefault(roleDef.deprecationDate));
        } else {
            setRefTypeEffectiveDate(getDateAttributeOrDefault(null));
            setRefTypeDeprecationDate(getDateAttributeOrDefault(null));
        }
        setSelectedOption(option);
        var newState = JSON.parse(JSON.stringify(state));
        newState.role = roleDef;

        var index = newState.findIndex((itm: any) => itm.dropdown === ddName);
        var selectedValue = { dropdown: ddName, dropdowntype: ddType, role: roleDef }


        if (index === -1) {
            newState.push(selectedValue)
        } else {
            newState[index] = selectedValue
        }
        newState.sort((a: any, b: any) => a.dropdown > b.dropdown ? 1 : -1);

        setState(newState);

    }


    const allowsDuplicateParts = (): boolean => {
        return false;
    }
    const getPartDefinition = function (partName: string): PartDefinition {
        var result : PartDefinition = { group: "new", name: partName, documentation: "", datatype: "", deprecationDate: null };
        if (partDefinitions) {
            var matches = partDefinitions.filter(pd => pd.name === partName);
            if (matches.length > 0) {
                result = matches[0];
            }
        }
        return result;
    }

    const hasInvalidIdChars = function (candidate: string): boolean {
        for (var c = 0; c < candidate.length; c++) {
            if (" ,;\"'\\(){}[]".indexOf(candidate[c]) >= 0) {
                console.log("invalid char: ", candidate[c], c);
                return true;
            }
        }
        return false;
    }
    const isUniqueId = function (candidate: string, idmap : any): boolean {
        if (idmap.hasOwnProperty(candidate)) {
            return false;
        }
        return true;
    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "CustomName":
                if (!customName) {
                    result = true;
                } else if (hasInvalidIdChars(customName)) {
                    result = false;
                } else if (!isUniqueId(customName,idMap)) {
                    result = false;
                } else if (customName.length === 0) {
                    return true;
                }
                break;
            case "Name":
                if (!refName || refName.length === 0) {
                    result = false;
                }
                break;
            case "documentation":
                //                if (!documentation || documentation.length === 0) {
                //                    result = false;
                //                }
                break;
        }
        return result;
    }
    const isAnyInvalid = () => {
        if (!isValid("UASID ") || !isValid("Name")) {
            return true;
        }
        if (selectedOption && selectedOption.name.length === 0) {
            return true;
        }
        return false;
    }

    const setTaxonomyDirty = function () {
        var estate: Edit = {
            IsDirty: true,
            Page: ""
        }
        dispatch(setIsTaxonomyDirty(estate));
    }

    const getDefaultEffectiveYear = function () {
        if (selectedVersion) {
            return (selectedVersion.year - 1) + "-10-01";
        }
        return null;
    }

    const handleAddNewReferenceRole = (e: any) => {
        // saving in changes slice
        var newRole: CustomReferenceRole = {
            name: "https://www.apps.fldfs.com/LocalGov/uas/roles/reference/" + customName,
            documentation: customDocumentation,
            effectiveDate: getDefaultEffectiveYear(),
            deprecationDate: null
        }
        dispatch(addReferenceRoleChange(newRole));
        setCustomName("");
        setCustomDocumentation("");
        setTaxonomyDirty();
    }

    function renderRoles(options: any) {

        return (
            <React.Fragment key={'ReferenceTypes'}>

                <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>Reference Types Available:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'ReferenceTypes'}
                                onChange={handleChange}
                                autoFocus
                                options={options}
                                isOptionDisabled={(option: any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                </Container>
            </React.Fragment >
        );
    }

    function generateDropdownValues(allRoles : CustomReferenceRole[], updateState: boolean) {

        var render: any[] = [];
        var ddState: Array<ddSelection> = [];
        var axe_i: number = 1;

        const options = getOptions(allRoles).map(opc => ({
            value: opc.name,
            label: opc.name,
            isdisabled: false
        }));

        options.sort((a, b) => a.value > b.value ? 1 : -1);


        // render accounts
        render.push(renderRoles(options));
        ddState.push({ dropdown: 'ReferenceTypes', dropdowntype: "CustomReferenceRole", role: null })


        if (updateState) {
            setState(ddState);
        }

        return render;

    }

    const [renderPage, setRenderPage] = useState(generateDropdownValues(collectReferenceRoles(roleChanges),false));

    const [partState, setPartState] = useState<Array<ddPartSelection>>([{
        dropdown: "",
        dropdowntype: "",
        part: null
    }]);

    const [customPartName, setCustomPartName] = useState("");
    const [customPartDocumentation, setCustomPartDocumentation] = useState("");

    const collectAllPartDefinitions = function (pdChanges : PartDefinition[] ): PartDefinition[] {
        var allDefs: PartDefinition[] = [];
        if (partDefinitions) {
            allDefs = allDefs.concat(partDefinitions);
        }
        if (partDefinitionChanges) {
            allDefs = allDefs.concat(pdChanges);
        }
        allDefs.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        return allDefs;
    }
    const [allPartDefinitions, setAllPartDefinitions] = useState<PartDefinition[]>(collectAllPartDefinitions(partDefinitionChanges));

    const getPartOptions = function (pdAll : PartDefinition[] ): ddPartOption[] {
        var options: ddPartOption[] = [];
        for (var pd of pdAll) {
            options.push({ name: getPartLabel(pd), documentation: pd.documentation });
        }
        return options;
    }
    const [selectedPartOption, setSelectedPartOption] = useState({ name: "", documentation: "" });

    // Handle Event
    const handlePartDefinitionChange = (e: any, action: any) => {

        var ddName: string = action.name;
        var partName: string = (e.value.indexOf(": ") > 0) ? e.value.split(": ")[1] : e.value.trim();
        var part: PartDefinition | null = null;
        var ddType = "Part";
        var option: ddPartOption = { name: "", documentation: "" };
        var partDef: PartDefinition | null | undefined = allPartDefinitions.find(po => po.name === partName);
        if (partDef) {
            option = { name: getPartLabel(partDef), documentation: partDef.documentation };
            var effectiveDate: string | null = getDefaultEffectiveYear();
            setPartDefinitionEffectiveDate(effectiveDate ? effectiveDate : "");
            setPartDefinitionDeprecationDate(getDateAttributeOrDefault(partDef.deprecationDate));
            setPartDefinitionDatatype(partDef.datatype);
        }
        setSelectedPartOption(option);
        var newState = JSON.parse(JSON.stringify(partState));


        var index = newState.findIndex((itm: any) => itm.dropdown === ddName);
        var selectedValue = { dropdown: ddName, dropdowntype: ddType, part: partDef }


        if (index === -1) {
            newState.push(selectedValue)
        } else {
            newState[index] = selectedValue
        }
        newState.sort((a: any, b: any) => a.dropdown.toLowerCase().localeCompare(b.dropdown.toLowerCase()));

        setPartState(newState);

    }
    const generatePartIdMap = function (allRoles: PartDefinition[]): any {
        const newIdMap: any =
            allRoles.reduce(function (map: any, pd: PartDefinition) {
                map[pd.name] = pd;
                return map;
            }, {})
        return newIdMap;
    }
    const [partIdMap, setPartIdMap] = useState(generatePartIdMap(allPartDefinitions));

    const isPartValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "CustomName":
                if (!customPartName) {
                    result = true;
                } else if (hasInvalidIdChars(customPartName)) {
                    result = false;
                } else if (!isUniqueId(customPartName, partIdMap)) {
                    result = false;
                } else if (customPartName.length === 0) {
                    return true;
                }
                break;
            case "CustomGroup":
                if (!customPartName) {
                    result = true;
                } else if (hasInvalidIdChars(customPartGroup)) {
                    result = false;
                }
                break;
            case "documentation":
                //                if (!documentation || documentation.length === 0) {
                //                    result = false;
                //                }
                break;
        }
        return result;
    }

    const handleNewPartDefinition = (e: any) => {
        // saving in changes slice
        var cpKey = customPartName;
        if (customPartGroup && customPartGroup.length === 0) {
            cpKey = customPartGroup + "/" + cpKey;
        }
        var newPartDef: PartDefinition = {
            name: customPartName,
            documentation: customPartDocumentation,
            datatype: customPartDefinitionDatatype,
            deprecationDate: null,
            //TODO what should group be?
            group: customPartGroup
        }
        dispatch(addPartDefinitionChange(newPartDef));
        setCustomPartGroup("");
        setCustomPartName("");
        setCustomPartDocumentation("");
        setSelectedPartOption({name: cpKey, documentation: customPartDocumentation });
        setTaxonomyDirty();
    }

    function renderParts(options: any) {

        return (
            <React.Fragment key={'ReferencePartDefinitions'}>

                <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>Parts Available:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'ReferencePartDefinitions'}
                                onChange={handlePartDefinitionChange}
                                autoFocus
                                options={options}
                                isOptionDisabled={(option: any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                </Container>
            </React.Fragment >
        );
    }

    function generateDropdownPartDefinitionValues(pdAll : PartDefinition[], updateState: boolean) {

        var render: any[] = [];
        var ddState: Array<ddPartSelection> = [];
        var axe_i: number = 1;
        const options = getPartOptions(pdAll).map(opc => ({
            value: opc.name,
            label: opc.name,
            isdisabled: false
        }));

        options.sort((a, b) => a.value > b.value ? 1 : -1);


        // render accounts
        render.push(renderParts(options));
        ddState.push({ dropdown: 'ReferencePartDefinitions', dropdowntype: "Part", part: null })


        if (updateState) {
            setPartState(ddState);
        }

        return render;

    }
    const [renderPartPage, setRenderPartPage] = useState(generateDropdownPartDefinitionValues(collectAllPartDefinitions(partDefinitionChanges), false));

    const handleDatatypeChange = function (event : any) {
        var value: string = event.target.value
        setCustomPartDefinitionDatatype(value);
    }

    const radioStyle = {
        marginLeft: "1em",
        marginRight: "1em",
        marginTop: "1em"
    }
    React.useEffect(() => {
        const rChanges: CustomReferenceRole[] = roleChanges;
        const rAll: CustomReferenceRole[] = collectReferenceRoles(rChanges);
        setAllReferenceRoles(rAll);
        setIdMap(generateRoleIdMap(rAll));
        setRenderPage(generateDropdownValues(rAll, true));
        setSelectedOption({ name: "", documentation: "", effectiveDate: null, deprecationDate: null });
        const pdChanges: PartDefinition[] = partDefinitionChanges;
        const pdAll: PartDefinition[] = collectAllPartDefinitions(pdChanges);
        setAllPartDefinitions(pdAll);
        setPartIdMap(generatePartIdMap(pdAll));
        setRenderPartPage(generateDropdownPartDefinitionValues(pdAll,true));
        setSelectedPartOption({ name: "", documentation: "" });

    }, [props]);

    React.useEffect(() => {
        const rChanges: CustomReferenceRole[] = roleChanges;
        const rAll: CustomReferenceRole[] = collectReferenceRoles(rChanges);
        setAllReferenceRoles(rAll);
        setIdMap(generateRoleIdMap(rAll));
        setRenderPage(generateDropdownValues(rAll, true));
        setSelectedOption({ name: "", documentation: "", effectiveDate: "", deprecationDate: "" });
        const pdChanges: PartDefinition[] = partDefinitionChanges;
        const pdAll: PartDefinition[] = collectAllPartDefinitions(pdChanges);
        setAllPartDefinitions(pdAll);
        setPartIdMap(generatePartIdMap(pdAll));
        setRenderPartPage(generateDropdownPartDefinitionValues(pdAll, true));
        setSelectedPartOption({ name: "", documentation: "" });

    }, [roleChanges]);

    React.useEffect(() => {
        const pdChanges: PartDefinition[] = partDefinitionChanges;
        const pdAll: PartDefinition[] = collectAllPartDefinitions(pdChanges);
        setAllPartDefinitions(pdAll);
        setRenderPartPage(generateDropdownPartDefinitionValues(pdAll, true));
        setSelectedPartOption({ name: "", documentation: "" });

    }, [partDefinitionChanges]);


    return (
        <React.Fragment >
                <div>
                    <h4>Managing Reference Types</h4>
                    <Row>
                        <Col>
                            {renderPage}
                            <Row xs="1">
                                {selectedOption.name.length > 0
                                    ?
                                    <div style={{ marginTop: "1em", marginRight: "1em", marginLeft: "1em", width: "100%" }} >
                                        <Toast>
                                            <ToastHeader><b>Description for {getShortTypeName(selectedOption)}</b></ToastHeader>
                                            <ToastBody>{selectedOption.documentation}</ToastBody>
                                        </Toast>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </Row>
                            <FormGroup>
                               <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Effective Date:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="date" value={refTypeEffectiveDate}
                                            onChange={(e) => setRefTypeEffectiveDate(e.currentTarget.value)}
                                            disabled={true}
                                            valid={isPartValid("EffectiveDate")}
                                            invalid={(!isPartValid("EffectiveDate"))} />
                                        <FormFeedback>Effective date must be less than deprecation date.</FormFeedback>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Deprecation Date:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="date" value={refTypeDeprecationDate}
                                            onChange={(e) => setRefTypeDeprecationDate(e.currentTarget.value)}
                                            valid={isValid("DeprecationDate")}
                                            invalid={(!isValid("DeprecationDate"))} />
                                        <FormFeedback>Deprecation date must be greater than effective date.</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col>
                            <div>
                                <button onClick={handleAddNewReferenceRole} disabled={customName.length === 0} className="btn btn-secondary mr-4">
                                    Add custom type
                                </button>
                            </div>
                            <FormGroup>

                                <Row>
                                    <Col >
                                        <Label><b>Custom type name:</b></Label>
                                        <Input type="text" value={customName}
                                            onChange={(e) => setCustomName(e.currentTarget.value)}
                                            valid={isValid("CustomName")}
                                            invalid={(!isValid("CustomName"))} />
                                        <FormFeedback>A custom name must be unique. No spaces or punctuation allowed.</FormFeedback>
                                        <Label><b>Documentation:</b></Label>
                                        <Input type="textarea" value={customDocumentation}
                                            onChange={(e) => setCustomDocumentation(e.currentTarget.value)}
                                            valid={isValid("CustomDocumentation")}
                                            invalid={(!isValid("CustomDocumentation"))} />
                                        <FormFeedback>Documentation is required.</FormFeedback>
                                    </Col>
                                </Row>

                            </FormGroup>
                        </Col>
                    </Row>
                    <h4>Managing Reference Part Definitions</h4>
                    <Row>
                        <Col>
                            {renderPartPage}
                            <Row xs="1">
                                {selectedPartOption.name.length > 0
                                    ?
                                    <div style={{ marginTop: "1em", marginRight: "1em", marginLeft: "1em", width: "100%" }} >
                                        <Toast>
                                            <ToastHeader><b>Part Description for {selectedPartOption.name}</b></ToastHeader>
                                            <ToastBody>{selectedPartOption.documentation}</ToastBody>
                                        </Toast>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </Row>
                        <FormGroup>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Datatype:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Label>{partDefinitionDatatype}</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Effective Date:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="date" value={partDefinitionEffectiveDate}
                                            onChange={(e) => setPartDefinitionEffectiveDate(e.currentTarget.value)}
                                            disabled={true}
                                            valid={isPartValid("EffectiveDate")}
                                            invalid={(!isPartValid("EffectiveDate"))} />
                                        <FormFeedback>Effective date must be less than deprecation date.</FormFeedback>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-md-right" >
                                        <Label><b>Deprecation Date:</b></Label>
                                    </Col>
                                    <Col md="9">
                                        <Input type="date" value={partDefinitionDeprecationDate}
                                            onChange={(e) => setPartDefinitionDeprecationDate(e.currentTarget.value)}
                                            valid={isPartValid("DeprecationDate")}
                                            invalid={(!isPartValid("DeprecationDate"))} />
                                        <FormFeedback>Deprecation date must be greater than effective date.</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col>
                        <FormGroup>
                                <Row>
                                    <Col>
                                        <button onClick={handleNewPartDefinition} disabled={customPartName.length === 0} className="btn btn-secondary mr-4">
                                            Add custom part
                                        </button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col >
                                        <Label><b>Custom part group:</b></Label>
                                        <Input type="text" value={customPartGroup}
                                            onChange={(e) => setCustomPartGroup(e.currentTarget.value)}
                                            valid={isPartValid("CustomGroup")}
                                            invalid={(!isPartValid("CustomGroup"))} />
                                        <FormFeedback>A custom part group cannot have spaces or punctuation.</FormFeedback>
                                        <Label><b>Custom part name:</b></Label>
                                        <Input type="text" value={customPartName}
                                            onChange={(e) => setCustomPartName(e.currentTarget.value)}
                                            valid={isPartValid("CustomName")}
                                            invalid={(!isPartValid("CustomName"))} />
                                        <FormFeedback>A custom name must be unique. No spaces or punctuation allowed.</FormFeedback>
                                        <Label><b>Documentation:</b></Label>
                                        <Input type="textarea" value={customPartDocumentation}
                                            onChange={(e) => setCustomPartDocumentation(e.currentTarget.value)}
                                            valid={isPartValid("CustomDocumentation")}
                                            invalid={(!isPartValid("CustomDocumentation"))} />
                                        <FormFeedback>Documentation is required.</FormFeedback>
                                        <Row>
                                            <Label className="ml-4" style={radioStyle}><b>Datatype</b></Label>
                                            <Label className="ml-4" style={radioStyle} check>
                                                <Input type="radio"
                                                    name="radioString"
                                                    value={"STRING"}
                                                    disabled={customPartName.length === 0}
                                                    onChange={handleDatatypeChange}
                                                    checked={(customPartDefinitionDatatype === "STRING")}
                                                /><b>Text</b>
                                            </Label>
                                            <Label className="ml-4" style={radioStyle} check>
                                                <Input type="radio"
                                                    name="radioString"
                                                    value={"DATE"}
                                                    disabled={customPartName.length === 0}
                                                    onChange={handleDatatypeChange}
                                                    checked={(customPartDefinitionDatatype === "DATE")}
                                                /><b>Date</b>
                                            </Label>
                                            <Label className="ml-4" style={radioStyle} check>
                                                <Input type="radio"
                                                    name="radioURI"
                                                    value={"ANYURI"}
                                                    disabled={customPartName.length === 0}
                                                    onChange={handleDatatypeChange}
                                                    checked={(customPartDefinitionDatatype === "ANYURI")}
                                                /><b>URI</b>
                                            </Label>
                                        </Row>
                                    </Col>
                                </Row>

                            </FormGroup>
                            <div>
                                <Table className="table" >
                                    <thead className="scrollable-table-header thead-dark">
                                        <tr>
                                            <th style={{ width: "10%" }}>Group</th>
                                            <th style={{ width: "10%" }}>Name</th>
                                            <th style={{ width: "10%" }}>Datatype</th>
                                            <th>Documentation</th>
                                        </tr>
                                    </thead>

                                <tbody>
                                    {partDefinitionChanges.map((option, idx) => (
                                            <tr>
                                                <td>{option.group}</td>
                                                <td>{option.name}</td>
                                                <td>{option.datatype}</td>
                                                <td>{option.documentation.indexOf("\n") < 0
                                                    ?
                                                    <span>{option.documentation}</span>
                                                    :
                                                    <div>
                                                        {option.documentation.split("\n").map((line) => (<p style={{ marginBottom: "0" }}>{line}</p>))}
                                                    </div>

                                                }</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>

                </div>
        </React.Fragment >
    );
}

export default ReferenceTypeAndPartManager;